import styled from '@emotion/styled';
import { Avatar } from 'components';

type TwoLineCell = {
  avatar?: boolean;
  first: string;
  second: string;
  big?: boolean;
  color?: string;
};

export const TwoLineCell = ({ avatar = false, first, second, color, big = false }: TwoLineCell) => {
  if (avatar) {
    return (
      <Cell big={big}>
        <Avatar letters={first} color={color} />
        <TwoLine>
          <First big={big}>{first}</First>
          <Second big={big}>{second}</Second>
        </TwoLine>
      </Cell>
    );
  }
  return (
    <TwoLine>
      <First big={big}>{first}</First>
      <Second big={big}>{second}</Second>
    </TwoLine>
  );
};

const First = styled.span<{ big: boolean }>`
  color: ${p => p.theme.palette.text.secondary};
  font-size: ${p => (p.big ? '1rem' : '0.75rem')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  min-width: 0;
  ${p => (p.big ? 'font-weight: 600;' : '')}
`;

const Second = styled.span<{ big: boolean }>`
  color: ${p => p.theme.palette.text.placeholder};
  font-size: ${p => (p.big ? '1rem' : '0.75rem')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  min-width: 0;
`;

const Cell = styled.div<{ big: boolean }>`
  display: flex;
  gap: ${p => (p.big ? '12px' : '8px')};
  align-items: center;
  width: 100%;
  min-width: 0;
  overflow: hidden;
`;

const TwoLine = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  min-width: 0;
  flex: 1;
`;
